import { v4 as uuidv4 } from 'uuid';
import { RefString } from "@tblabs/truffle";
import { IStorageUser } from '@tblabs/storage';


export class UserRef
{
    public Id = "";
    public Name = new RefString();
    public Login = new RefString();
    public Email = new RefString();
    public Role = new RefString("User");
    public Icon = new RefString("👤");
    public Password = new RefString();
    public Tags = new RefString();
    public Privileges = new RefString();

    constructor(user?: IStorageUser)
    {
        this.Id = user?.Id ?? uuidv4();
        this.Name.value = user?.Name ?? "";
        this.Login.value = user?.Login ?? "";
        this.Email.value = user?.Email ?? "";
        this.Role.value = user?.Role ?? "User";
        this.Icon.value = user?.Icon ?? "👤";
        this.Password.value = user?.Password ?? "";
        this.Tags.value = user?.Tags?.join(" ") ?? "";
        this.Privileges.value = user?.Privileges ? JSON.stringify(user.Privileges, null, 2) : "{}";
    }

    public get AsRaw(): IStorageUser
    {
        const privileges = JSON.parse(this.Privileges.value);

        return {
            Id: this.Id,
            Name: this.Name.value.trim(),
            Login: this.Login.value.trim(),
            Email: this.Email.value.trim(),
            Role: this.Role.value.trim(),
            Icon: this.Icon.value.trim(),
            Password: this.Password.value.trim(),
            Tags: this.Tags.value.trim().split(" "),
            Privileges: privileges,
        } as IStorageUser;
    }
}
